export default __webpack_public_path__ + "static/media/KidcoGrillGuide3@2x.d33e037a.jpg";